export default {"src":"/_next/static/media/logo_dark.634a5fcc.svg","height":24,"width":175,"blurWidth":0,"blurHeight":0};